import { Button } from "@mui/material";
import LoadingSpinner from "components/LoadingSpinner";
import React, { useEffect, useState } from "react";
import { getFormattedDate } from "utils/date";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";
import dayjs from "dayjs";
import FormDatePicker from "components/FormFields/FormDatePicker";
import { DATE_FORMAT } from "static/date";

const LetterNextSendsModal = ({
  isModalOpen,
  onClose,
  isLoading,
  onDownload,
  letterNextSendDate,
}) => {
  const [nextSendDate, setNextSendDate] = useState();
  const [submitClicked, setSubmitClicked] = useState(false);

  useEffect(() => {
    if (letterNextSendDate) {
      setNextSendDate(letterNextSendDate);
    }
  }, [letterNextSendDate]);

  const handleGenerate = () => {
    setSubmitClicked(true);
    if (!nextSendDate) {
      return;
    }
    onDownload(nextSendDate);
  };

  return (
    <ModalWrapper
      title="Letter Next Send Date"
      show={isModalOpen}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
    >
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <div className="mt-2 mb-2 generate-template-modal__content">
            <p>
              {nextSendDate
                ? "A next send date has been calculated. You can modify it below if needed before generating the letter."
                : "Please select a next send date to continue."}
            </p>
          </div>

          <FormDatePicker
            required
            className="mt-2 mb-2"
            name="next_send_date"
            label="Next Send Date"
            value={nextSendDate ? dayjs(nextSendDate) : null}
            hasError={submitClicked && !nextSendDate}
            errorMessage="Select a valid next send date to generate letter"
            onChange={(date) => {
              const formattedDate = date
                ? getFormattedDate(date, DATE_FORMAT.DEFAULT)
                : null;
              setNextSendDate(
                formattedDate !== "Invalid Date" ? formattedDate : null
              );
              setSubmitClicked(false);
            }}
          />

          <div className="mt-2 generate-template-modal__footer">
            <Button variant="outlined" color="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              style={{ backgroundColor: "#94ba33", color: "white" }}
              onClick={handleGenerate}
            >
              Generate
            </Button>
          </div>
        </>
      )}
    </ModalWrapper>
  );
};

export default LetterNextSendsModal;
